import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-drawer',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-drawer works!</p> `,
  styles: ``,
})
export class CpDrawerComponent {}
